/* Premium Polish Experiment. Safe, progressive enhancement only. */
(function () {
  'use strict';

  var doc = document.documentElement;
  var body = document.body;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!body || !body.classList.contains('template-index')) return;
  doc.classList.add('pp-js');

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    enhanceReveal();
    enhanceCounters();
    if (!reduceMotion) {
      enhanceTilt();
      enhanceMagneticButtons();
    }
  });

  function enhanceReveal() {
    var groups = [
      ['.hero-label, .hero-heading, .hero-subtext, .hero-buttons, .hero-stats', 'left'],
      ['.hero-image-inner', 'right'],
      ['.cs-copy > *', 'left'],
      ['.cs-card', 'right'],
      ['#featured-products > div > div:first-child, .wm-fp-card', 'zoom'],
      ['.visual-break-content', 'zoom'],
      ['.features-heading-wrap, .feature-card', 'zoom'],
      ['.wm-reviews-header, .wm-reviews-overall, .wm-review-card', 'zoom'],
      ['.cta-inner', 'zoom']
    ];

    var revealItems = [];
    groups.forEach(function (group) {
      var selector = group[0];
      var mode = group[1];
      Array.prototype.forEach.call(document.querySelectorAll(selector), function (el, index) {
        if (!el || el.classList.contains('pp-reveal')) return;
        el.classList.add('pp-reveal');
        el.setAttribute('data-pp-reveal', mode);
        el.style.setProperty('--pp-delay', Math.min(index * 80, 420) + 'ms');
        revealItems.push(el);
      });
    });

    if (!revealItems.length) return;

    if (!('IntersectionObserver' in window)) {
      revealItems.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    revealItems.forEach(function (el) { observer.observe(el); });
  }

  function enhanceCounters() {
    var values = Array.prototype.slice.call(document.querySelectorAll('.hero-stats .stat-value'));
    if (!values.length || reduceMotion || !('IntersectionObserver' in window)) return;

    values.forEach(function (el) {
      var text = (el.textContent || '').trim();
      var match = text.match(/^([0-9]+(?:\.[0-9]+)?)(.*)$/);
      if (!match) return;
      el.setAttribute('data-pp-final', text);
      el.setAttribute('data-pp-number', match[1]);
      el.setAttribute('data-pp-suffix', match[2] || '');
      el.textContent = '0' + (match[2] || '');
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        animateNumber(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.4 });

    values.forEach(function (el) {
      if (el.getAttribute('data-pp-number')) observer.observe(el);
    });
  }

  function animateNumber(el) {
    var target = parseFloat(el.getAttribute('data-pp-number'));
    var suffix = el.getAttribute('data-pp-suffix') || '';
    var decimals = (String(target).split('.')[1] || '').length;
    var start = performance.now();
    var duration = 1200;

    function tick(now) {
      var t = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      var value = target * eased;
      el.textContent = value.toFixed(decimals) + suffix;
      if (t < 1) requestAnimationFrame(tick);
      else el.textContent = el.getAttribute('data-pp-final');
    }
    requestAnimationFrame(tick);
  }

  function enhanceParallax() {
    var hero = document.querySelector('.hero-section');
    var visual = document.querySelector('.visual-break');
    var ticking = false;

    function setVars() {
      ticking = false;
      if (hero) {
        var hr = hero.getBoundingClientRect();
        var hp = Math.max(-1, Math.min(1, (window.innerHeight * 0.5 - hr.top) / Math.max(hr.height, 1) - 0.5));
        hero.style.setProperty('--pp-hero-y', (hp * -38).toFixed(2) + 'px');
      }
      if (visual) {
        var vr = visual.getBoundingClientRect();
        var vp = Math.max(-1, Math.min(1, (window.innerHeight * 0.5 - vr.top) / Math.max(vr.height, 1) - 0.5));
        visual.style.setProperty('--pp-visual-y', (vp * -54).toFixed(2) + 'px');
      }
    }

    function request() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(setVars);
    }

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request, { passive: true });
    request();
  }

  function enhanceTilt() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('.cs-card, .wm-fp-card, .wm-shop-card, .feature-card'));
    if (!cards.length || !window.matchMedia('(pointer: fine)').matches) return;

    cards.forEach(function (card) {
      card.addEventListener('pointermove', function (event) {
        var rect = card.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width;
        var y = (event.clientY - rect.top) / rect.height;
        var rotateY = (x - 0.5) * 7;
        var rotateX = (0.5 - y) * 7;
        card.style.setProperty('--pp-tilt-x', rotateX.toFixed(2) + 'deg');
        card.style.setProperty('--pp-tilt-y', rotateY.toFixed(2) + 'deg');
        card.style.setProperty('--pp-x', (x * 100).toFixed(2) + '%');
        card.style.setProperty('--pp-y', (y * 100).toFixed(2) + '%');
        card.style.setProperty('--pp-card-glow', '1');
      });

      card.addEventListener('pointerleave', function () {
        card.style.setProperty('--pp-tilt-x', '0deg');
        card.style.setProperty('--pp-tilt-y', '0deg');
        card.style.setProperty('--pp-card-glow', '0');
      });
    });
  }

  function enhanceMagneticButtons() {
    var buttons = Array.prototype.slice.call(document.querySelectorAll('.btn, .cs-main-cta, #featured-products a[style*="background:#5F3334"]'));
    if (!buttons.length || !window.matchMedia('(pointer: fine)').matches) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('pointermove', function (event) {
        var rect = btn.getBoundingClientRect();
        var x = event.clientX - (rect.left + rect.width / 2);
        var y = event.clientY - (rect.top + rect.height / 2);
        btn.style.setProperty('--pp-mx', (x * 0.12).toFixed(2) + 'px');
        btn.style.setProperty('--pp-my', (y * 0.18).toFixed(2) + 'px');
      });

      btn.addEventListener('pointerleave', function () {
        btn.style.setProperty('--pp-mx', '0px');
        btn.style.setProperty('--pp-my', '0px');
      });
    });
  }
})();
